import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MyButton from '../../../utils/MyButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { getTareasClienteFiltrado, postTareaCliente, getClienteTareas } from '../../../redux/actions/dataactions';
import { clearErrors } from '../../../redux/actions/dataactions';



import { FaArrowLeft, FaPlus, FaFirstAid, FaChartBar, FaCheckCircle, FaCheck, FaCircle } from "react-icons/fa";
import './CrearTarea.css';

export class CrearTarea extends Component {
  constructor() {
    super();
    this.state = {
      handlecreador: '',
      nombretarea: '',
      detalles: '',
      fechaplazo: '',
      horaplazo: '',
      prioridad: '',
      handleasignado: '',
      tipotarea: '',
      errors: {},
      aprobado: {},
      open: false
    };

  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }

    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }



  handleOpen = () => {
    this.props.getClienteTareas(this.props.clienteId)
    this.setState({
      handlecreador: '',
      nombretarea: '',
      detalles: '',
      fechaplazo: '',
      horaplazo: '',
      prioridad: '',
      handleasignado: '',
      tipotarea: '', open: true, aprobado: {}
    });
  };


  handleClose = () => {


    if (this.state.aprobado.mensaje) {
      //getEquipos this.handleEditProgMto();
      this.props.getTareasClienteFiltrado(this.props.clienteId, "01/01/1950", "01/01/2035");

      this.setState({
        handlecreador: '',
        nombretarea: '',
        detalles: '',
        fechaplazo: '',
        horaplazo: '',
        prioridad: '',
        handleasignado: '',
        tipotarea: '',
        open: false, errors: {}, aprobado: {}
      });
    } else {
      this.setState({

        open: false, errors: {}, aprobado: {}
      });
    }



  };



  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };


  handleSubmit = (event) => {
    event.preventDefault();
    const userhandle = this.props.user.credentials.handle;

    const newUserData = {
      handlecreador: userhandle,
      nombretarea: this.state.nombretarea,
      detalles: this.state.detalles,
      fechaplazo: this.state.fechaplazo,
      horaplazo: this.state.horaplazo,
      prioridad: this.state.prioridad,
      handleasignado: this.state.handleasignado,
      tipotarea: this.state.tipotarea


    };

    console.log(newUserData)

    this.props.postTareaCliente(newUserData, this.props.clienteId);



  }

  render() {
    const { UI: { loading } } = this.props;
    const { errors } = this.state;
    const { ingenieros } = this.props.data.cliente;
    return (



      <Fragment>

        <div className='div-card-link' onClick={this.handleOpen}>
          <div className="dashing-cardcontent">
            <div className="dashing-cardtext">
              <p className="dashing-text-card">
                Crear Tarea
              </p>

            </div>
            <div className="dashing-cardicon">
              <FaFirstAid color="#FFFFFF" className="dashing-icon" />
            </div>
          </div>


        </div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >

          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>¡Creación de Tarea Exitosa!</h2>
            </div>

          ) : (<div>

            <DialogTitle sx={{ color: '#03178C', fontWeight: 'bold' }}>Crear Tarea</DialogTitle>

            <DialogContent>

              <form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1 }}>
                      Información de la Tarea
                    </Typography>
                    <TextField
                      required
                      type="text"
                      name="nombretarea"
                      id="nombretarea"
                      label="Nombre de la Tarea"
                      value={this.state.nombretarea}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.nombretarea}
                      error={Boolean(errors.nombretarea)}
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      required
                      type="text"
                      name="detalles"
                      id="detalles"
                      label="Detalles de la Tarea"
                      value={this.state.detalles}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      multiline
                      rows={3}
                      helperText={errors.detalles}
                      error={Boolean(errors.detalles)}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1, mt: 1 }}>
                      Planificación y Organización
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="date"
                      name="fechaplazo"
                      id="fechaplazo"
                      label="Fecha de Vencimiento"
                      value={this.state.fechaplazo}
                      onChange={this.handleChange}
                      inputProps={{ min: "2019-01-01", max: "2029-01-01" }}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      helperText={errors.fechaplazo}
                      error={Boolean(errors.fechaplazo)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="time"
                      name="horaplazo"
                      id="horaplazo"
                      label="Hora de Vencimiento"
                      value={this.state.horaplazo}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      helperText={errors.horaplazo}
                      error={Boolean(errors.horaplazo)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={Boolean(errors.prioridad)}>
                      <InputLabel>Prioridad</InputLabel>
                      <Select
                        required
                        name="prioridad"
                        id="prioridad"
                        value={this.state.prioridad}
                        onChange={this.handleChange}
                        label="Prioridad"
                      >
                        <MenuItem value=""><em>Ninguno</em></MenuItem>
                        <MenuItem value="Alta">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaCircle color="#f2545b" size={10} /> Alta
                          </Box>
                        </MenuItem>
                        <MenuItem value="Media">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaCircle color="#f5c26b" size={10} /> Media
                          </Box>
                        </MenuItem>
                        <MenuItem value="Baja">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaCircle color="#00bda5" size={10} /> Baja
                          </Box>
                        </MenuItem>
                      </Select>
                      {errors.prioridad && <FormHelperText>{errors.prioridad}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={Boolean(errors.tipotarea)}>
                      <InputLabel>Tipo de Tarea</InputLabel>
                      <Select
                        required
                        name="tipotarea"
                        id="tipotarea"
                        value={this.state.tipotarea}
                        onChange={this.handleChange}
                        label="Tipo de Tarea"
                      >
                        <MenuItem value=""><em>Ninguno</em></MenuItem>
                        <MenuItem value="Biomedica">Biomedica</MenuItem>
                        <MenuItem value="Infraestructura">Infraestructura</MenuItem>
                        <MenuItem value="Computo">Computo</MenuItem>
                        <MenuItem value="Mobiliario">Mobiliario</MenuItem>
                        <MenuItem value="Industrial">Industrial</MenuItem>
                      </Select>
                      {errors.tipotarea && <FormHelperText>{errors.tipotarea}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1, mt: 1 }}>
                      Personal Responsable
                    </Typography>
                    {ingenieros && ingenieros.length > 0 ? (
                      <FormControl fullWidth size="small" error={Boolean(errors.handleasignado)}>
                        <InputLabel id="tecnico-label">Personal designado para esta tarea</InputLabel>
                        <Select
                          required
                          name="handleasignado"
                          id="handleasignado"
                          value={this.state.handleasignado}
                          onChange={this.handleChange}
                          label="Personal designado para esta tarea"
                        >
                          {ingenieros.map((ingeniero, index) => (
                            <MenuItem key={index} value={ingeniero}>
                              @{ingeniero}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.handleasignado && <FormHelperText>{errors.handleasignado}</FormHelperText>}
                      </FormControl>
                    ) : (
                      <Typography variant="body2" color="error">
                        Este perfil de ingeniería no tiene técnicos asociados. Por favor, cree uno o más técnicos en "Perfil Técnico".
                      </Typography>
                    )}
                  </Grid>

                </Grid>
              </form>


            </DialogContent>
          </div>)}


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>

            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleClose}>
                  <FaCheckCircle color="#20B90C" className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Crear Tarea" onClick={this.handleSubmit}>
                  <FaPlus color="#03178C" className="icon-formulario" />
                </MyButton>
              )
            )}




          </DialogActions>
        </Dialog>
      </Fragment>

    )
  }
}

CrearTarea.propTypes = {
  getTareasClienteFiltrado: PropTypes.func.isRequired,
  postTareaCliente: PropTypes.func.isRequired,
  getClienteTareas: PropTypes.func.isRequired,
  clienteId: PropTypes.string.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};

const mapActionsToProps = { getTareasClienteFiltrado, getClienteTareas, postTareaCliente, clearErrors };

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
  UI: state.UI
})



export default connect(mapStateToProps, mapActionsToProps)(CrearTarea);
